// extracted by mini-css-extract-plugin
export default {"root":"styles_root__l4nNY","detail":"styles_detail__yWguM","text":"styles_text__p9-xd"};